var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.useChip)?_c('v-chip',{class:_vm.chipClass,attrs:{"small":_vm.small,"label":""}},[_c('Date',{attrs:{"value":_vm.displayDate}})],1):_c('span',[_c('Date',{attrs:{"value":_vm.displayDate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }